import React, { useState, useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Navigate, useNavigate } from 'react-router-dom';
import GlassLayout from '../components/GlassLayout';
import OtpInput from '../containers/Auth/OtpInputs';
import { store } from '../redux/store/index';
import * as loginActions from '../redux/actions/loginActions';
import { connect } from 'react-redux';
import { useSession } from '../context/SessionContext';
import { trackEvent } from '../utils/firebase';

const Login = ({ authReducer }) => {

  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('')
  const [countryCode] = useState('+91')
  const { isAuthenticated } = useSession()

  useEffect(() => {
    const { status, authError } = authReducer;

    if (status === 'success from sign in' && phone) {
      navigate('/verify-otp', { state: { phone, countryCode } });
    }
    else if (status === 'failure') {
      setError(authError);
    }
  }, [authReducer]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (phone.length !== 10) return;
    
    trackEvent('login_started', { method: 'phone' });
    
    store.dispatch(loginActions.authSignInRequestAction(phone, process.env.REACT_APP_ONI_PLATFORM, countryCode));
  };

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  } else {
    return (
      <GlassLayout>
          <form onSubmit={handleSubmit}>

        <Typography variant="h4" mb={5} align='center' fontWeight={'bold'}>
          Welcome to ONI
        </Typography>

        <Typography mb={1} align='left'>
          Enter Phone Number
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            mb: 2,
          }}
        >
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '15%',
            backgroundColor: '#FFF',
            height: '41px',
            borderRadius: '5px',
            marginRight: '5px',
            color: 'black',
          }}>
            <Typography style={{ fontSize: '18px' }}>{countryCode}</Typography>
          </Box>
          <OtpInput
            value={phone}
            valueLength={10}
            onChange={(data) => {
              setPhone(data);
              if (error) setError('');
            }}
          />
        </Box>
        {
          error && <Typography>{error}</Typography>
        }
        <Button
          type="submit" 
          variant="contained"
          sx={{
            backgroundColor: '#fbc02d',
            color: '#ffff',
            textTransform: 'none',
            width: '80%',
            fontSize: '18px',
            '&:hover': {
              backgroundColor: '#f9a825',
            },
            mt: 4
          }}
          loading={authReducer.requestState}
        >
          Continue
        </Button>
        </form>
      </GlassLayout>
    );
  }

};

const mapStateToProps = (state) => {
  const { authReducer } = state;
  return { authReducer };
};

export default connect(mapStateToProps)(Login);
